/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "User",
  size: 20
}

const SvgUser = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.1} cx={9.9} cy={6.4} r={4.4} />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M1.5 19c.8-4.5 4.3-7.8 8.5-7.8s7.7 3.4 8.5 8"
    />
  </Svg>
)

SvgUser.defaultProps = defaultProps
export default SvgUser
